import React from "react";
import { Spinner } from "react-bootstrap";
export function LoadingSpinner(){
return (
<div className="fadein"><Spinner style={{display:"block", width:75,height:75,marginTop:20,marginBottom:25,marginLeft:"auto",marginRight:"auto"}} animation="border" variant="primary" /></div>
)
}